export default "__VITE_ASSET__74b7cf17__"